import { render, staticRenderFns } from "./AddIcon.vue?vue&type=template&id=d4416f76"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4416f76')) {
      api.createRecord('d4416f76', component.options)
    } else {
      api.reload('d4416f76', component.options)
    }
    module.hot.accept("./AddIcon.vue?vue&type=template&id=d4416f76", function () {
      api.rerender('d4416f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/AddIcon.vue"
export default component.exports